/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { BuilderPermission } from '@gh/builder-shared-data';
import { ImmutablePageState, isRouteForCreationMode, queryFormMode, State, UserContext } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';

import { LeadDetailsInit } from '../../resources/lead.model';
import { LeadDetailsCommandService } from './lead-details-command.service';
import { LeadDetailsState, queryLeadDirty } from './lead-details.state';

@Injectable()
export class LeadDetailsFormState extends ImmutablePageState<LeadDetailsState> {
  constructor(private route: ActivatedRoute,
              private userContext: UserContext,
              private commands: LeadDetailsCommandService,
              state: State<LeadDetailsState>) {
    super(state, {
      dirty: queryLeadDirty,
      formMode: queryFormMode,
    });
  }

  build(details: LeadDetailsInit): void {
    const mode = isRouteForCreationMode(this.route)
      ? FormMode.CreateMode : (this.userContext.hasPermission(BuilderPermission.Sales.Leads.EDIT)
        ? FormMode.EditMode : FormMode.ViewMode);

    this.commands.load(details, mode);
  }

}
